import React, { useState } from 'react';
import { Box, Input, Button } from '@lucid/lego';
import { useStore } from '../../../store/store';
import styles from './ConfigureShortCode.module.scss';

export type ConfigureShortCodeProps = {
  onConfigureVehicle?: (shortCode: string) => void;
};

/**
 * Configure with short code tab content for creating vehicle quotations
 * @component
 * @param props - Component props
 * @param props.onConfigureVehicle - Callback when user submits a short code
 * @returns JSX.Element
 *
 * @example
 * <ConfigureShortCode onConfigureVehicle={(code) => handleConfigure(code)} />
 */
const ConfigureShortCode: React.FC<ConfigureShortCodeProps> = ({ onConfigureVehicle }) => {
  const theme = useStore((state) => state.theme);
  const invertedTheme = theme === 'dark' ? 'light' : 'dark';
  const [shortCode, setShortCode] = useState('');

  const handleSubmit = () => {
    if (onConfigureVehicle && shortCode.trim()) {
      onConfigureVehicle(shortCode.trim());
    }
  };

  return (
    <Box className={styles.configureShortCode} data-theme={invertedTheme}>
      <Box className={styles.content}>
        <Input
          name="shortCode"
          placeholder="Enter Short Code"
          value={shortCode}
          onChange={(e) => setShortCode(e.target.value)}
          theme={invertedTheme}
          showValidation={false}
        />
        <Button
          label="CONFIGURE VEHICLE"
          type="primary"
          color="neutral"
          theme={invertedTheme}
          handleClick={handleSubmit}
          isFluid
          gaComponent="configure-short-code-button"
          dataTestId="configure-short-code-button"
        />
      </Box>
    </Box>
  );
};

export default ConfigureShortCode;
